import React from "react";

export default () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M17.8654 5.85496L20.6454 8.64496C20.8354 8.83496 20.8354 9.15496 20.6354 9.34496L17.8554 12.135C17.5454 12.455 17.0054 12.235 17.0054 11.785V9.99496H10.9954C10.4454 9.99496 9.99539 9.54496 9.99539 8.99496C9.99539 8.44496 10.4454 7.99496 10.9954 7.99496H17.0154V6.20496C17.0154 5.76496 17.5554 5.53496 17.8654 5.85496ZM3.35539 14.645L6.13539 11.855C6.44539 11.535 6.98539 11.755 6.98539 12.205V13.995H12.9954C13.5454 13.995 13.9954 14.445 13.9954 14.995C13.9954 15.545 13.5454 15.995 12.9954 15.995H6.98539V17.795C6.98539 18.235 6.44539 18.465 6.13539 18.145L3.35539 15.355C3.16539 15.155 3.16539 14.845 3.35539 14.645Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
